import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom'
import { Image, Tabs } from '@chakra-ui/react';

import HomeLayout from '../../../components/layouts/homelayout';
import AsiaTabPanel from './asiatabpanel'
import NATabPanel from './natabpanel'
import EuropeTabPanel from './europetabpanel'
import naBanner from '../../../components/ui/regionalcareers/NAHero.jpg'
import euBanner from '../../../components/ui/regionalcareers/Europe-Hero.jpg'
import aBanner from '../../../components/ui/regionalcareers/Asia_Hero.png'

export default function OurRegions() {
  const tabMap = useMemo(() => new Map([
    [0, "tab-c40defabe206bb77568"],
    [1, "tab-92a940378463b5a55aa"],
    [2, "tab-8a6e0fbdfb7865841e4"]
  ]), []);

  const [searchParams, setSearchParams] = useSearchParams();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabsChange = useCallback((index) => {
    setSearchParams(tabMap.get(index), { replace: true });
    setTabIndex(index)
  }, [tabMap, setSearchParams]);

  useEffect(() => {
    if (searchParams.has(tabMap.get(0))) {
      handleTabsChange(0);
    } else if (searchParams.has(tabMap.get(1))) {
      handleTabsChange(1);
    } else if (searchParams.has(tabMap.get(2))) {
      handleTabsChange(2);
    } 
  }, [tabMap, searchParams, handleTabsChange])

  return (
    <HomeLayout align="center">
      <Tabs.Root w="full" index={tabIndex} onChange={handleTabsChange}>

          <Tabs.Content p={0}>
          
              <Image src={naBanner} className='page-banner' />
            
          </Tabs.Content>
          <Tabs.Content p={0}>
            
              <Image src={aBanner} className='page-banner' />
            
          </Tabs.Content>
          <Tabs.Content p={0}>
          
              <Image src={euBanner} className='page-banner' />
            
          </Tabs.Content>


        <Tabs.List>
          <Tabs.Trigger>North America</Tabs.Trigger>
          <Tabs.Trigger>Asia</Tabs.Trigger>
          <Tabs.Trigger>Europe</Tabs.Trigger>
        </Tabs.List>


          <Tabs.Content>
           <NATabPanel />
          </Tabs.Content>
          <Tabs.Content>
            <AsiaTabPanel />
          </Tabs.Content>
          <Tabs.Content>
            <EuropeTabPanel />
          </Tabs.Content>

      </Tabs.Root>
    </HomeLayout>
  );
}
